import React from 'react'
import { getGridTemplateColumns } from '../helper'
import { TableV2RowStyled } from './index.styled'

const TableV2Row = React.memo(({
	headers = [], columns = [], children, testId, className,
	isActive, isDisabled,
	onDoubleClick, onClick,
}) => {
	const gridTemplateColumns = getGridTemplateColumns({ headers, columns })
	const layout = (isActive ? 'active ' : '') + (isDisabled ? 'disabled ' : '') + className

	return (
		<TableV2RowStyled columns={gridTemplateColumns}
											data-testid={testId}
											className={layout}
											onDoubleClick={onDoubleClick}
											onClick={onClick}>
			{children}
		</TableV2RowStyled>
	)
})

TableV2Row.displayName = 'TableV2Row'
export default TableV2Row
